<!-- src/App.vue -->
<template>
  <div id="app">
    <HeaderSection />
    <router-view></router-view>
    <CommunitySection />
    <FooterSection />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderSection from './components/HeaderSection.vue'
import FooterSection from './components/FooterSection.vue'
import CommunitySection from './components/CommunitySection.vue'

export default {
  name: 'App',
  components: {
    HeaderSection,
    FooterSection,
    CommunitySection
  },
  methods: {
    ...mapActions(['fetchNakaHistory', 'fetchPFPInfos', 'fetchOpenSeaInfo'])
  },
  created() {
    this.fetchNakaHistory()
    this.fetchPFPInfos()
    this.fetchOpenSeaInfo()
  }
}
</script>

<style lang="scss">
@import '@/assets/css/reset.scss';
@import '@/assets/css/style.scss';

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#main {
  flex: 1;
}
</style>
